import type { SxProps, Theme } from '@/ui/primitives';

export const authFieldLabelSx: SxProps<Theme> = {
  fontSize: '17px',
  lineHeight: 1.35,
};

export const authTextFieldSx: SxProps<Theme> = {
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
    fontSize: '17px',
    lineHeight: 1.35,
  },
  '& .MuiInputBase-input, & .MuiOutlinedInput-input, & input': {
    fontSize: '17px',
    lineHeight: 1.35,
  },
  '& .MuiInputBase-input::placeholder, & .MuiOutlinedInput-input::placeholder, & input::placeholder':
    {
      color: 'text.secondary',
      fontSize: '17px',
      lineHeight: 1.35,
      opacity: 1,
    },
};
